<template>
  <v-dialog
    max-width="300px"
    v-model="showDialog"
  >
    <v-card>
      <v-card-text
        class="pa-0"
      >
        <video
          v-if="videoId"
          width="300"
          controls
          playsinline
          autoplay
          loop
          controlslist="nodownload"
          :src='srcDialog'
        />
        <video
          v-else
          width="300"
          controls
          playsinline
          autoplay
          loop
          :src='srcDialog'
        />
      </v-card-text>
      <v-card-actions
        v-if="videoId"
        class="card-actions"
      >
        <v-btn
          color="orange"
          small
          icon
          @click.stop="downloadVideo()"
        >
          <v-icon>
            mdi-download
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    src: {
      type: String,
      default: '',
    },

    videoId: {
      type: Number,
      default: null,
    },
  },

  name: 'DialogVideoPlayer',

  data: () => ({
    showDialog: false,
    srcDialog: '',
  }),

  methods: {
    downloadVideo() {
      this.$requestHelpers
        .get(
          `api/admin/video/download/${this.videoId}`,
          {
            responseType: 'blob',
          },
        ).then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const headerval = response.headers['content-disposition'];
          const filename = headerval.match(/filename="(.*)"/);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename[1]);
          fileLink.click();
        });
    },
  },

  watch: {
    show(val) {
      this.showDialog = val;
    },

    showDialog(val) {
      this.srcDialog = val ? this.src : '';
      this.$emit('update:src', this.srcDialog);
      this.$emit('update:show', val);
    },
  },
};
</script>

<style scoped>
.card-actions {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
}
</style>
